<template>
  <div
    class="header-wrapper"
    :class="{ abs: isAbsolute }"
    :style="{ 'background-color': `${backgroundColor}` }"
  >
    <div class="inner-container desktop">
      <div class="left-side">
        <router-link to="/" class="logo">
          <img
            class="pointer logo"
            src="@/assets/images/virsody-logo-blue-v2.svg"
            alt=""
            width="148px"
            height=""
          />
        </router-link>
        <span>虛擬展間的第一選擇</span>
      </div>
      <div class="right-side">
        <div class="mid">
          <router-link
            to="https://virsody.io/"
            class="pointer link"
            :class="{ active: state === STATE.HOME }"
          >
            <!-- 首頁 -->
            {{ $t('COMMON.WORD.HOME') }}
          </router-link>
          <router-link
            to="https://virsody.io/pricing"
            class="pointer link"
            :class="{ active: state === STATE.PRICING }"
          >
            <!-- 服務方案 -->
            {{ $t('COMMON.WORD.SERVICE_PLAN') }}
          </router-link>
        </div>
        <a
          :href="$store.state.panelWebsite"
          target="_blank"
          class="hover-border pointer reg"
        >
          {{ $t('AUTH.WORD.SIGN_IN') }}
        </a>
      </div>
    </div>
    <div class="menu-container mobile-1076">
      <router-link to="/" class="logo">
        <img
          class="pointer logo"
          src="@/assets/images/virsody-logo-blue-v2.svg"
          alt=""
          width="148px"
          height=""
        />
      </router-link>
      <div
        class="hamburger"
        @click="overlayToggle = !overlayToggle"
        :class="{
          active: overlayToggle
        }"
      >
        <div class="rect"></div>
        <div class="rect"></div>
        <div class="rect"></div>
      </div>
      <div
        class="full-overlay"
        :class="{
          active: overlayToggle
        }"
        @mousemove="overlayToggle = true"
      >
        <div class="menu-slots">
          <a href="https://virsody.io/" class="menu-slot">
            <!-- 首頁 -->
            {{ $t('COMMON.WORD.HOME') }}
          </a>
          <a href="https://virsody.io/pricing" class="menu-slot">
            <!-- 服務方案 -->
            {{ $t('COMMON.WORD.SERVICE_PLAN') }}
          </a>
        </div>
        <!-- <div class="bottom-container">
                    <a :href='$store.state.panelWebsite' target="_blank" class='login'>登入</a>
                    <div class="langs">
                        <a href="" class='active'>中文</a>
                        <a href="" class=''>EN</a>
                    </div>
                </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      state: 0,
      STATE: Object.freeze({
        HOME: 0,
        EXPLORE: 1,
        PRICING: 2,
        MY_EXHIBITION: 3
      }),
      overlayToggle: false
    };
  },
  props: {
    isAbsolute: {
      default: false,
      type: Boolean
    },
    backgroundColor: {
      default: `rgba(11, 11, 11, .75)`,
      type: String
    }
  },
  watch: {
    $route(to, from) {
      const path = to?.path || '';
      if (path.includes('/explore')) {
        this.state = this.STATE.EXPLORE;
      } else if (path.includes('/pricing')) {
        this.state = this.STATE.PRICING;
      } else {
        this.state = this.STATE.HOME;
      }
    }
  },
  created() {
    const path = this.$route?.path || '';
    if (path.includes('/explore')) {
      this.state = this.STATE.EXPLORE;
    } else if (path.includes('/pricing')) {
      this.state = this.STATE.PRICING;
    }
  },
  mounted() {
    // console.log(this.$store.state);
  },
  methods: {
    switchLang(e) {
      const lang = e?.target?.value;
      this.$store.commit('setLang', lang);
    },
    switchState(iState) {
      this.state = iState;
      switch (iState) {
        case this.STATE.HOME:
          this.$router.push({ name: 'index' });
          break;
        case this.STATE.EXPLORE:
          this.$router.push({ name: 'explore' });
          break;
        case this.STATE.PRICING:
          this.$router.push({ name: 'pricing' });
          break;
        case this.STATE.MY_EXHIBITION:
          this.$router.push({ name: 'index' });
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/mixins';
select {
  /* Reset Select */
  -o-appearance: none;
  -ms-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  appearance: none;
  outline: 0;
  border: 0;
  box-shadow: none;
  /* Personalize */
  flex: 1;
  padding: 0 1em;
  color: #fff;
  background-image: none;
  cursor: pointer;
}
/* Remove IE arrow */
select::-ms-expand {
  display: none;
}
h1 {
  margin: 0 0 0.25em;
}
a {
  text-decoration: inherit;
}
.desktop {
  @media screen and (max-width: 1076px) {
    opacity: 0;
    pointer-events: none;
    position: absolute;
  }
}
.mobile-1076 {
  opacity: 0;
  pointer-events: none;
  transition: all 0.25s ease-in-out;
  @media screen and (max-width: 1076px) {
    opacity: 1;
    pointer-events: all;
  }
}
.full-overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #070707;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 64px;
  opacity: 0;
  transition: all 0.25s ease-in-out;
  &.active {
    pointer-events: all;
    opacity: 1;
  }
  .menu-slots {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .menu-slot {
      font-size: 18px;
      letter-spacing: 0.02em;
      line-height: 26px;
      color: #fff;
      margin-bottom: 80px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.25s ease-in-out;
      position: relative;

      &:nth-child(1) {
        margin-top: 120px;
      }
      &:nth-child(1),
      &:nth-child(2) {
        position: relative;
        &::after {
          content: '';
          width: 270px;
          height: 1px;
          background-color: #5a5a5a;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -40px;
        }
      }
      &.active,
      &:hover {
        color: #00b6f0;
      }
    }
  }
  .bottom-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .login {
      width: 270px;
      height: 45px;
      background-color: #00b6f0;
      color: #fff;
      font-size: 14px;
      letter-spacing: 0.02em;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      cursor: pointer;
    }
    .langs {
      display: flex;
      margin-top: 48px;
      a {
        font-size: 18px;
        letter-spacing: 0.02em;
        font-weight: 400;
        line-height: 24px;
        color: #fff;
        margin: 0 30px;
        transition: all 0.25s ease-in-out;
        cursor: pointer;
        &.active,
        &:hover {
          font-weight: 700;
          color: #00b6f0;
        }
      }
    }
  }
}
.menu-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 34px;
  @media screen and (min-width: 1076px) {
    display: none;
  }
  .logo {
    z-index: 9999;
  }
  .hamburger {
    width: 28px;
    z-index: 9999;
    cursor: pointer;
    .rect {
      width: 100%;
      height: 3px;
      background-color: #00b6f0;
      margin-bottom: 6px;
      transition: all 0.25s ease-in-out;
      &:nth-child(1) {
      }
      &:nth-child(2) {
      }
      &:nth-child(3) {
        margin-bottom: 0;
      }
    }
    &.active {
      :nth-child(1) {
        transform: rotate(45deg) translate(6px, 8px);
      }
      :nth-child(2) {
        opacity: 0;
      }
      :nth-child(3) {
        transform: rotate(-45deg) translate(4px, -7px);
      }
    }
  }
}
.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  z-index: 999;
  position: relative;
  transition: all 0.25s ease-in-out;
  &.abs {
    position: fixed;
    z-index: 999;
  }
  .inner-container {
    display: flex;
    width: 100%;
    //max-width: 1200px;
    max-width: 1120px;
    // @include laptop-1200 {
    //     max-width: 820px;
    // }
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    transition: all 0.25s ease-in-out;
    .left-side {
      display: flex;
      align-items: center;
      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      span {
        font-size: 14px;
        letter-spacing: 0.02em;
        color: #ffffff;
        margin-left: 28px;
      }
    }
    .right-side {
      display: flex;
      align-items: center;
      position: relative;
      border-radius: 5px;
      .mid {
        margin-left: 88px;
        display: flex;
        align-items: center;
        .link {
          color: var(--neutral);
          font-size: 14px;
          letter-spacing: 0.02em;
          margin: 0 16px;
          transition: all 0.3s ease-in-out;
          &.active {
            position: relative;
            color: #fff;
            &::after {
              position: absolute;
              content: '';
              top: calc(100% + 11px);
              left: 50%;
              transform: translateX(-50%);
              width: calc(100% + 4px);
              height: 6px;
              background-color: var(--primary);
            }
          }
        }
      }
      .lang-select-wrapper {
        position: relative;
        display: flex;
        width: 20em;
        height: 3em;
        border-radius: 0.25em;
        overflow: hidden;
        background-color: transparent;
        select {
          line-height: normal;
          background-color: transparent;
          option {
            height: 40px;
          }
        }
      }
      a {
        height: 34px;
        border-radius: 5px;
        border: none;
        padding: 8px 22px;
        transition: all 0.25s ease;
        font-size: 14px;
        letter-spacing: 0.02em;
        &.login {
          color: var(--primary);
          background-color: transparent;
          border: 1px solid var(--primary);
          margin-left: 12px;
        }
        &.reg {
          background-color: var(--primary);
          color: #fff;
          margin-left: 12px;
          border: 1px solid transparent;
        }
        &.hover-border {
          &:hover {
            border: 1px solid #fff;
          }
        }
        transition: 0.2s ease-in all;
      }
    }
  }
}
</style>